import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c00568a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mx-5" }
const _hoisted_2 = { class: "card main-table-container" }
const _hoisted_3 = { class: "card-header align-items-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "card-title my-2" }, "Detalle", -1))
const _hoisted_5 = { class: "d-flex justify-content-end" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-left" }, null, -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Volver ")
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "card-body p-0" }
const _hoisted_10 = {
  id: "example1_wrapper",
  class: "dataTables_wrapper dt-bootstrap4"
}
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-sm-12" }
const _hoisted_13 = { class: "card mb-0 border-right-0 border-left-0" }
const _hoisted_14 = { class: "card-header border-top" }
const _hoisted_15 = { class: "card-title" }
const _hoisted_16 = { class: "d-flex justify-content-end" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { class: "w-100 h-100" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("   Descargar log ")
const _hoisted_20 = { class: "table-responsive table-container" }
const _hoisted_21 = {
  key: 0,
  class: "position-absolute overlay w-100 h-100 mx-auto"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-2x fa-sync-alt fa-spin" }, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { class: "tableFixHead" }
const _hoisted_25 = {
  id: "example1",
  class: "table table-bordered table-striped dataTable dtr-inline mb-0",
  role: "grid",
  "aria-describedby": "example1_info"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { role: "row" }, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "sorting sorting_asc",
      rowspan: "1",
      colspan: "1"
    }, " Código PNF "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "sorting sorting_asc",
      rowspan: "1",
      colspan: "1"
    }, " Fecha del reporte "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "sorting sorting_asc",
      rowspan: "1",
      colspan: "1"
    }, " Nombre notificador "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "sorting sorting_asc",
      rowspan: "1",
      colspan: "1"
    }, " Tipo documento "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "sorting sorting_asc",
      rowspan: "1",
      colspan: "1"
    }, " # documento "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "sorting sorting_asc",
      rowspan: "1",
      colspan: "1"
    }, " Iniciales "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "sorting sorting_asc",
      rowspan: "1",
      colspan: "1"
    }, " Nombre comercial del medicamento "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "sorting sorting_asc",
      rowspan: "1",
      colspan: "1"
    }, " Medicamento Implicado "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "sorting sorting_asc",
      rowspan: "1",
      colspan: "1"
    }, " Estado "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "sorting sorting_asc",
      rowspan: "1",
      colspan: "1"
    }, " Código Vigiflow ")
  ])
], -1))
const _hoisted_27 = {
  key: 0,
  class: "position-relative"
}
const _hoisted_28 = {
  key: 1,
  class: "position-relative"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    class: "dtr-control sorting_1 mx-auto",
    tabindex: "0",
    colspan: "8"
  }, /*#__PURE__*/_toDisplayString(`No hay registros`))
], -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "col-sm-12" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "mb-3 mt-5 ml-1 card-title" }, " Log de errores: ", -1))
const _hoisted_34 = { class: "table-responsive table-container" }
const _hoisted_35 = {
  key: 0,
  class: "position-absolute overlay w-100 h-100 mx-auto"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-2x fa-sync-alt fa-spin" }, null, -1))
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = { class: "tableFixHead" }
const _hoisted_39 = {
  id: "example1",
  class: "table table-bordered table-striped dataTable dtr-inline mb-0",
  role: "grid",
  "aria-describedby": "example1_info"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { role: "row" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "sorting" }, "Línea"),
    /*#__PURE__*/_createElementVNode("th", { class: "sorting" }, "Error"),
    /*#__PURE__*/_createElementVNode("th", { class: "sorting" }, "Fecha"),
    /*#__PURE__*/_createElementVNode("th", { class: "sorting" }, "# documento")
  ])
], -1))
const _hoisted_41 = {
  key: 0,
  class: "position-relative"
}
const _hoisted_42 = {
  key: 1,
  class: "position-relative"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    class: "dtr-control sorting_1",
    tabindex: "0",
    colspan: "4"
  }, /*#__PURE__*/_toDisplayString(`No hay registros`))
], -1))
const _hoisted_44 = [
  _hoisted_43
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary btn-sm",
            onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.goToUploadedFiles && _ctx.goToUploadedFiles(...args)))
          }, _hoisted_8)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("h4", _hoisted_15, " Registros procesados: " + _toDisplayString(_ctx.records.length), 1),
                  _createElementVNode("div", _hoisted_16, [
                    (_ctx.records.length || _ctx.logs.length)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "btn btn-outline-success btn-sm",
                          onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.downloadFile && _ctx.downloadFile(...args))),
                          disabled: _ctx.btnLoading
                        }, [
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("i", {
                              class: _normalizeClass([_ctx.btnLoading? 'fas fa-2x fa-sync-alt fa-spin' : 'fas fa-file-download'])
                            }, null, 2),
                            _hoisted_19
                          ])
                        ], 8, _hoisted_17))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("table", _hoisted_25, [
                      _hoisted_26,
                      (_ctx.records && _ctx.records.length > 0)
                        ? (_openBlock(), _createElementBlock("tbody", _hoisted_27, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.records, (item, index) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                class: "odd",
                                key: index
                              }, [
                                _createElementVNode("td", null, _toDisplayString(item.codigo_pnf), 1),
                                _createElementVNode("td", null, _toDisplayString(item.fecha_del_reporte), 1),
                                _createElementVNode("td", null, _toDisplayString(item.nombre_notificador), 1),
                                _createElementVNode("td", null, _toDisplayString(item.id_del_reporte), 1),
                                _createElementVNode("td", null, _toDisplayString(item.nro_identificacion_paciente), 1),
                                _createElementVNode("td", null, _toDisplayString(item.iniciales), 1),
                                _createElementVNode("td", null, _toDisplayString(item.nombre_comercial_del_medicamento), 1),
                                _createElementVNode("td", null, _toDisplayString(item.medicamentoImplicado), 1),
                                _createElementVNode("td", null, _toDisplayString(item.estado), 1),
                                _createElementVNode("td", null, _toDisplayString(item.id_reporte), 1)
                              ]))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock("tbody", _hoisted_28, _hoisted_30))
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _hoisted_33,
              _createElementVNode("div", _hoisted_34, [
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, _hoisted_37))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("table", _hoisted_39, [
                    _hoisted_40,
                    (_ctx.logs && _ctx.logs.length > 0)
                      ? (_openBlock(), _createElementBlock("tbody", _hoisted_41, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logs, (item, index) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              class: "odd",
                              key: index
                            }, [
                              _createElementVNode("td", null, _toDisplayString(item.linea), 1),
                              _createElementVNode("td", null, _toDisplayString(item.error), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.moment(item.fecha_creacion).format("YYYY-MM-DD")), 1),
                              _createElementVNode("td", null, _toDisplayString(item.cedula), 1)
                            ]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("tbody", _hoisted_42, _hoisted_44))
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}